export const LocalDevProvider = {
  get name() {
    return 'LOCAL_DEV_PROVIDER';
  },

  isRotationEnabled(config) {
    return config.dev.creatives.length > 1;
  },

  rotationInterval(config) {
    return config.defaultRotationInterval;
  },

  test(config) {
    return config.dev.enabled && config.dev.creatives.length > 0;
  },

  nextCreative(config, { wallpaper }) {
    // This is a way to rotate through the elements of an array, because the
    // modulo operator will always return an index inside the array length range
    const nextPosition = wallpaper.position % config.dev.creatives.length;
    const nextCreative = config.dev.creatives[nextPosition];

    return nextCreative;
  },
};
